module.exports = __webpack_public_path__ + "media/metronic/_theme/media/project-logos/5-571cf3ad70f8fc4ae5c07a5edc3fc8e2.png";